import Vue from 'vue'
import axios from 'axios'

export default {
    state: {
        gotInitialLoggedUserInfo: false,
        isLoggedIn: false,
        info: []
    },

    actions: {
        'loggedUserModel/fetchLoggedUserInfo': function (context, callback) {
            axios.get('/api/login').then(
                (response) => {
                    context.commit('loggedUserModel/setLoggedUserInfo', response.data);
                    context.state.gotInitialLoggedUserInfo = true;

                    if (callback && typeof callback === 'function') {
                        callback(response.data);
                    }
                }
            )
        },
        'loggedUserModel/logOut': function (context, callback) {
            axios.get('/api/login', {
                params: {
                    logOut: true
                }
            }).then(
                (response) => {
                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                }
            )
        }
    },

    mutations: {
        'loggedUserModel/setLoggedUserInfo': function (state, data) {
            state.isLoggedIn = data.isLoggedIn;
            state.info = data.info;
        },

        'loggedUserModel/unsetLoggedUserInfo': function (state) {
            state.isLoggedIn = false;
            state.info = {};
        }
    }

}


// WEBPACK FOOTER //
// ./src/Common/LoggedUserModel.js